import { InvoiceItem } from "@/modules/invoiceItems/models";

export class Accrual {
  id = 0;
  invCode = "";
  invNo = 0;
  // 1 = számla szintű elhatárolás, egyébként a számlatétel azonosítója (tétel szintű)
  invItem = 1;
  amount = 0;
  startDate = "";
  endDate = "";
  isDailyRate = false;
  items: AccrualAmount[] = [];

  constructor(params?: Partial<Accrual>) {
    const data = { ...params };
    Object.assign(this, data);
  }
}

// Tétel szintű elhatárolás: számlatételenként külön elhatárolási időszak
export class AccrualInvoiceItem {
  invItem: number;
  item: InvoiceItem;
  startDate: string;
  endDate: string;
  isDailyRate = false;
  expanded = false;
  // A sor alatti sárga megerősítő sáv (törlés az elhatárolásból) nyitva van-e
  confirmDelete = false;
  // A tétel nincs az elhatárolásban: a felhasználó törölte, vagy a mentett tételes
  // elhatárolásból hiányzik. A tételes Kalkuláció (minden tétel újragenerálása) vagy az egész
  // elhatárolás törlése utáni újragenerálás hozza vissza.
  removed = false;
  // A mentett tétel szintű elhatárolás (hmaccseparparam sor) azonosítója, 0 ha még nincs mentve
  accrualId = 0;
  // A tétel elhatárolandó összege: mentett elhatárolásnál a tárolt fej összeg,
  // egyébként a számított alap (nettó + le nem vonható ÁFA-hányad)
  baseAmount = 0;
  // A tétel forint nettó/bruttó értéke (a backend base számításából, megjelenítéshez)
  nettoHuf = 0;
  bruttoHuf = 0;
  // Havi bontás — a dátumok/napi bontás módosításakor újragenerálódik, az összegek szerkeszthetők
  items: AccrualAmount[] = [];

  constructor(item: InvoiceItem, startDate: string, endDate: string) {
    this.invItem = item.invoiceItemID;
    this.item = item;
    this.startDate = startDate;
    this.endDate = endDate;
  }
}

export class AccrualAmount {
  id = 0;
  accDate = "";
  amount = 0;
  details = false;

  constructor(params?: Partial<AccrualAmount>) {
    const data = { ...params };
    Object.assign(this, data);
  }
}

// Elhatárolható összegek ÁFA-levonhatóság szerint (backend számítja)
export class AccrualBase {
  // Számla szintű összeg: a számla nettója + a tételek le nem vonható ÁFA-hányada
  total = 0;
  items: AccrualItemBase[] = [];

  constructor(params?: Partial<AccrualBase>) {
    const data = { ...params };
    Object.assign(this, data);
  }
}

// Egy számlatétel elhatárolható összege: nettó + a le nem vonható ÁFA-hányad
export class AccrualItemBase {
  invoiceItemID = 0;
  amount = 0;
  // a tétel forint nettó/bruttó értéke (megjelenítéshez)
  netto = 0;
  brutto = 0;
  // számviteli törvény: csak az 5-9. számlaosztály határolható el, az 1-4. nem (a backend dönti el
  // a tétel főkönyvi száma alapján); ismeretlen főkönyvi számnál igaz
  isAccruable = true;
}
